import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder } from "ticketino-api-client";

import contactDetailImg from "../images/visitor-img_2.png";

import Header from "./components/Header";

const BRANCH_OPTIONS = [
    "Asset Management",
    "Banking & Insurance",
    "Fintech & Innovation",
    "IT & Informatics",
    "Consulting",
    "Pension & Retirement Services",
    "Public Administration",
    "Real Estate & Property",
    "Trust Services & Trustes",
    "Education & Academia",
    "Wealth & Private Banking",
    "Family Office Services",
    "Tax & Legal Advisory",
    "Foundations & Philanthropy",
    "Other Financial Services"
];

const FUNCTION_OPTIONS = [
    "Asset Allocator:in",
    "CEO / CIO",
    "Finanzberater:in",
    "Fondsselektor:in",
    "Pensionskassen Vertreter:in",
    "Portfolio Manager:in",
    "Private Banker:in",
    "Steuerberater:in",
    "Stiftungsvertreter:in",
    "Trustee",
    "Unabhängige Vermögensverwalter:in",
    "Other: (Feld eingabe)*"
];

const STELLUNG_OPTIONS = [
    "Owner / Partner",
    "Managing Director",
    "Upper Management",
    "Employee",
    "Other: (Feld eingabe)*"
];

const Visitor_Step20_ContactDetails = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [organizerId, setOrganizerId] = useState(0);

    const [branchValue, setBranchValue] = useState("");
    const [functionValue, setFunctionValue] = useState("");
    const [stellungValue, setStellungValue] = useState("");

    const [functionOther, setFunctionOther] = useState("");
    const [stellungOther, setStellungOther] = useState("");

    const [buyerInfo, setBuyerInfo] = useState({
        code5: "",
        code6: "",
        code7: "",
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    const isFunctionOther = functionValue.startsWith("Other");
    const isStellungOther = stellungValue.startsWith("Other");
    const isNextDisabled =
        branchValue === "" ||
        functionValue === "" ||
        stellungValue === "" ||
        (isFunctionOther && functionOther.trim() === "") ||
        (isStellungOther && stellungOther.trim() === "");

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId)
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate("/de/visitor/home");
                }

                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/de/visitor/home");
            }
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder === null) {
                navigate("/de/visitor/home")
            }

            setOrder(updatedOrder);
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleBranchChange = (e) => {
        setBranchValue(e.target.value);
    };

    const handleFunctionChange = (e) => {
        setFunctionValue(e.target.value);
        if (!e.target.value.startsWith("Other")) setFunctionOther("");
    };

    const handleStellungChange = (e) => {
        setStellungValue(e.target.value);
        if (!e.target.value.startsWith("Other")) setStellungOther("");
    };

    const onSubmit = async () => {
        const updatedBuyerInfo = {
            ...buyerInfo,
            branch: branchValue,
            function: isFunctionOther ? "Other: " + functionOther : functionValue,
            stellung: isStellungOther ? "Other: " + stellungOther : stellungValue
        };
        setBuyerInfo(updatedBuyerInfo);
        await addAddressToBasket(updatedBuyerInfo);
    }

    const addAddressToBasket = async (buyerInfoToSend = buyerInfo) => {
        // Retrieve existing addressBody from localStorage
        let existingAddressBody = {};
        try {
            existingAddressBody = JSON.parse(localStorage.getItem("addressBody")) || {};
        } catch (e) {
            existingAddressBody = {};
        }

        // Merge new fields with existing ones
        let addressBody = {
            ...existingAddressBody,
            code5: buyerInfoToSend.branch,
            code6: buyerInfoToSend.function,
            code7: buyerInfoToSend.stellung
        };

        // Save updated addressBody to localStorage
        localStorage.setItem("addressBody", JSON.stringify(addressBody));

        // Navigate to the next step
        navigate(`/${language}/visitor/address`);
    };

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">

                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                        <span className="text-subtitle d-block">{resources?.VisitorContactDetailsTitle}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-5 mb-2 mt-4 mt-md-2">
                        <img className="img-fluid" src={contactDetailImg} alt="contact detail" />
                    </div>

                    <div className="col-md-7">

                        {/* Branch dropdownlist */}
                        <div className="mt-4 mt-md-1"><span>{resources?.VisitorContactDetailsBranch}</span></div>
                        <div className="mt-2 mb-5">
                            <select
                                id="branchDropdown"
                                className="form-select"
                                value={branchValue}
                                onChange={handleBranchChange}
                            >
                                <option value=""></option>
                                {BRANCH_OPTIONS.map((option, idx) => (
                                    <option key={idx} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>

                        {/* Funktion dropdownlist */}
                        <div><span>{resources?.VisitorContactDetailsFunction}</span></div>
                        <div className="mt-2 mb-5">
                            <select
                                id="functionDropdown"
                                className="form-select"
                                value={functionValue}
                                onChange={handleFunctionChange}
                            >
                                <option value=""></option>
                                {FUNCTION_OPTIONS.map((option, idx) => (
                                    <option key={idx} value={option}>{option}</option>
                                ))}
                            </select>
                            {isFunctionOther && (
                                <input
                                    type="text"
                                    className="form-control mt-2"
                                    placeholder="Bitte angeben..."
                                    value={functionOther}
                                    onChange={e => setFunctionOther(e.target.value)}
                                />
                            )}
                        </div>

                        {/* Stellung dropdownlist */}
                        <div><span>{resources?.VisitorContactDetailsStellung}</span></div>
                        <div className="mt-2 mb-3">
                            <select
                                id="stellungDropdown"
                                className="form-select"
                                value={stellungValue}
                                onChange={handleStellungChange}
                            >
                                <option value=""></option>
                                {STELLUNG_OPTIONS.map((option, idx) => (
                                    <option key={idx} value={option}>{option}</option>
                                ))}
                            </select>
                            {isStellungOther && (
                                <input
                                    type="text"
                                    className="form-control mt-2"
                                    placeholder="Bitte angeben..."
                                    value={stellungOther}
                                    onChange={e => setStellungOther(e.target.value)}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-6">
                        <button className="btn button-custom" onClick={() => navigate(-1)}>{resources?.Back}</button>
                    </div>
                    <div className="col-md-6 text-end">
                        <button className="btn button-custom" onClick={() => onSubmit()} disabled={isNextDisabled}>{resources?.Next}</button>
                    </div>
                </div>

                <p className="mt-4">
                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                </p>
            </div>
        </div>
    )
}

export default Visitor_Step20_ContactDetails